import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Company } from '../../shared/models/companies';
import { Balance } from '../../shared/models/balances';
import { HttpApiService } from './http/http-api.service';
import { HttpRequestMethod } from './http/request-methods';

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  companiesCollection: AngularFirestoreCollection<Company>;
  balanceCollection: AngularFirestoreCollection<Balance>;
  companyDoc: AngularFirestoreDocument<Company>;
  companies: Observable<Company[]>;
  company: Observable<Company>;
  balance: Observable<Balance>;
  
  balance_company = {
    id: '',
    companyId: '',
    companyName: '',
    companyLegalName: '',
    balance: 0,
    transactions: []
    }

  constructor(
    private httpApiService: HttpApiService,
    private afs: AngularFirestore
    ) {
    this.companiesCollection = this.afs.collection('companies');
    this.balanceCollection = this.afs.collection('balances');
  }

  getCompanies(): Observable<Company[]> {
    return this.companiesCollection.valueChanges({ idField: 'id'})
  }
  getCompany(id:string): Observable<Company>{
    this.companyDoc = this.afs.doc<Company>(`companies/${id}`);
    this.company = this.companyDoc.snapshotChanges().pipe(
      map((action) => {
        if (action.payload.exists === false) {
          return null;
        } else {
          const data = action.payload.data() as Company;
          data.id = action.payload.id;
          return data;
        }
      })
    );
    return this.company;
  }

  newCompany(
      company: Company
    ): Promise<{ company: Company } | any> {
    return new Promise(async (resolve, reject) => {
      try {
        const savingNewCcompany = await this.companiesCollection.add(
          JSON.parse(JSON.stringify(company))
        );
        resolve(savingNewCcompany.id);
        const itemObj: any = {};
        itemObj.id = savingNewCcompany.id;
        this.updateEvent(itemObj);

        this.balance_company.companyId = itemObj.id;
        this.balance_company.companyLegalName = company.companyLegalName;
        this.balance_company.companyName = company.companyName;
        const savingNewBalance = await this.balanceCollection.add(
          JSON.parse(JSON.stringify(this.balance_company))
        );
        resolve(savingNewBalance.id);
        const myBalance: any = {};
        myBalance.id = savingNewBalance.id;
        this.updateBalance(myBalance);
      } catch (err) {
        reject(err);
      }
    });
  }

  updateEvent(event: Company): Promise<{ event: Event } | any> {
    return new Promise(async (resolve, reject) => {
      try {
        const updatingItem = await this.afs
          .collection('companies')
          .doc(event.id)
          .update(event);
        resolve(updatingItem);
      } catch (err) {
        reject(err);
        console.log(err);
      }
    });
  }

  updateBalance(event: Balance): Promise<{ event: Event } | any> {
    return new Promise(async (resolve, reject) => {
      try {
        const updatingItem = await this.afs
          .collection('balances')
          .doc(event.id)
          .update(event);
        resolve(updatingItem);
      } catch (err) {
        reject(err);
        console.log(err);
      }
    });
  }

    async updateCompany(
     docId: string,
     newData: any
   ): Promise<{ company: Company } | any> {
     try {
       let response = await this.afs.doc(`companies/${docId}`).update(JSON.parse(JSON.stringify(newData)));
       return response;
     } catch (error) {
       console.log(error);
     }
  }

    getCompanyAsPromise(id: string): Promise<Company | null> {
    return new Promise((resolve, reject) => {
      this.afs.doc<Company>(`companies/${id}`)
      .valueChanges()
      .pipe(
        take(1)
      )
      .subscribe( client => {
        resolve(client);
      }, error => reject);
    });
  }

  crearContrato(company: Company){
    return this.httpApiService.apiNestJs<any>(HttpRequestMethod.POST,`contrato/createBase64`,company, {responseType: 'arraybuffer'});
  }

  enviarContratoAFirma(company: Company){
    return this.httpApiService.apiNestJs<any>(HttpRequestMethod.POST,`contrato/uploadContrato`,company);
  }

  changeStatusContrato(idContrato: string, idCompany: string, status: number, widgetId: string){
    const params = {
      idContrato: idContrato,
      idCompany: idCompany,
      status: status,
      widgetId: widgetId
    };
    return this.httpApiService.apiNode<any>(HttpRequestMethod.POST,`contrato/changeStatus`,params);
  }

  getStatusContrato(idCompany: string){
    return this.httpApiService.apiNode<any>(HttpRequestMethod.GET,`contrato/getStatus/${idCompany}`);
  }

  /**
   * 
   * @param idCompany 
   * @returns 
   */
  getCards(idCompany: number) {
    return this.httpApiService.apiNode<any>(HttpRequestMethod.POST,`company/cards`, {
      companyId: idCompany
    });
  }
}
